import { IDataPoint } from "@formant/core/model/IDataPoint";
import { StreamType } from "@formant/core/model/StreamType";

export function findNearestDataPoint<T extends StreamType = StreamType>(
    dataPoints: IDataPoint<T>[],
    time: number | Date,
): IDataPoint<T> | undefined {
    const t = typeof time === "number" ? time : time.getTime();
    const timeDistance = Number.MAX_SAFE_INTEGER;
    let nearest: IDataPoint<T> | undefined;
    dataPoints.forEach(dataPoint => {
        const [timestamp] = dataPoint;
        if (Math.abs(t - timestamp) < timeDistance) {
            nearest = dataPoint;
        }
    });
    return nearest;
}
